<div class="pre-medico-container">
    <form [formGroup]="form">
        <div class="form-actions">
            <!--
                Salvar/Cancelar ficam AQUI, em botão, e só enquanto a edição está aberta: nessa hora são
                as duas únicas saídas, e escondê-las atrás de um menu custaria um clique a mais em cada
                uma. Quem abre a edição é o item "Editar" do menu de Ações, no cabeçalho do card — ver
                `card-servicos`.
            -->
            @if (editando()) {
                <p-button type="button" [label]="salvando() ? 'Salvando...' : 'Salvar'" icon="pi pi-save" [loading]="salvando()" [disabled]="salvando()" [appCan]="rolePreMedicoEditar" (onClick)="salvarEdicao()" />
                <p-button type="button" label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" [disabled]="salvando()" (onClick)="cancelarEdicao()" />
            }
        </div>

        <section class="wizard-progresso" aria-label="Progresso do cadastro">
            <div class="wizard-progresso-topo">
                <strong>Etapa {{ indiceEtapaAtual() + 1 }} de {{ etapasWizard.length }}</strong>
                <span>{{ etapasWizard[indiceEtapaAtual()].rotulo }}</span>
            </div>
            <div class="wizard-progresso-trilha"><span [style.width.%]="progressoWizard()"></span></div>
        </section>

        @if (erroEtapa()) {
            <div class="historico-feedback erro">{{ erroEtapa() }}</div>
        }

        @if (mensagemAtualizacao()) {
            <app-card-content [headerColor]="false" [title]="'Atualizacao'" [icon]="iconeDaSecao('Atualizacao')" [subtitle]="subtituloDaSecao('Atualizacao')">
                <pre>{{ mensagemAtualizacao() }}</pre>
            </app-card-content>
        }

        <!-- Apenas uma aba de conteúdo por enquanto: DADOS -->
        @if (abaSelecionada() === EAbaPreMedico.DADOS) {
            <app-card-content [headerColor]="false" [title]="'Identificação'" [icon]="iconeDaSecao('Identificação')" [subtitle]="subtituloDaSecao('Identificação')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label class="font-semibold block mb-2">Categoria</label>
                        <p-select [appendTo]="'body'" formControlName="categoria" [options]="categorias" placeholder="Selecionar" class="w-full" />
                    </div>
                    <div class="field periodo-field">
                        <div>
                            <label class="font-semibold block mb-2">Período</label>
                            <p-inputmask formControlName="periodoDe" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                        <div class="periodo-separador">até</div>
                        <div>
                            <label class="font-semibold block mb-2 invisible md:visible">&nbsp;</label>
                            <p-inputmask formControlName="periodoAte" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Filiação'" [icon]="iconeDaSecao('Filiação')" [subtitle]="subtituloDaSecao('Filiação')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label class="font-semibold block mb-2">Nome do Pai</label>
                        <input pInputText formControlName="nomePai" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Nome da Mãe</label>
                        <input pInputText formControlName="nomeMae" class="w-full" />
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Nascimento e Naturalidade'" [icon]="iconeDaSecao('Nascimento e Naturalidade')" [subtitle]="subtituloDaSecao('Nascimento e Naturalidade')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label class="font-semibold block mb-2">Dt. Nasc.</label>
                        <p-inputmask formControlName="dtNasc" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Nacionalidade</label>
                        <p-select [appendTo]="'body'" formControlName="nacionalidade" [options]="nacionalidades" placeholder="Selecionar" class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label class="font-semibold block mb-2">País</label>
                        <p-select [appendTo]="'body'" formControlName="pais" [options]="paises" placeholder="Selecionar" class="w-full" />
                    </div>
                    <div class="field naturalidade-field">
                        <div>
                            <label class="font-semibold block mb-2">Naturalidade</label>
                            <input pInputText formControlName="naturalidadeCidade" class="w-full" placeholder="Cidade" />
                        </div>
                        @if (!isEstrangeiro) {
                            <div>
                                <label class="font-semibold block mb-2">&nbsp;</label>
                                <input pInputText formControlName="naturalidadeUf" class="w-full" placeholder="UF" />
                            </div>
                        }
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Dados Complementares'" [icon]="iconeDaSecao('Dados Complementares')" [subtitle]="subtituloDaSecao('Dados Complementares')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label class="font-semibold block mb-2">Sexo</label>
                        <!-- Requisito: Radio trocado para p-select -->
                        <p-select [appendTo]="'body'" formControlName="sexo" [options]="sexos" placeholder="Selecionar" class="w-full" />
                    </div>

                    <div class="field">
                        <label class="font-semibold block mb-2">Estado Civil</label>
                        <p-select [appendTo]="'body'" formControlName="estadoCivil" [options]="estadosCivis" placeholder="Selecionar" class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label class="font-semibold block mb-2">Tipo Sanguíneo</label>
                        <p-select [appendTo]="'body'" formControlName="tipoSanguineoABO" [options]="tiposSanguineosABO" placeholder="ABO" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Fator</label>
                        <p-select [appendTo]="'body'" formControlName="tipoSanguineoRh" [options]="tiposSanguineosRh" placeholder="Rh" class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label class="font-semibold block mb-2">Local de Trabalho</label>
                        <input pInputText formControlName="localTrabalho" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Visto</label>
                        <!-- Requisito: usar p-select para o tipo de visto -->
                        <p-select [appendTo]="'body'" formControlName="visto" [options]="vistos" placeholder="Selecionar" class="w-full" />
                    </div>
                </div>
            </app-card-content>
        }
        @if (abaSelecionada() === EAbaPreMedico.TEL) {
            <app-card-content [headerColor]="false" [title]="'Telefone'" [icon]="iconeDaSecao('Telefone')" [subtitle]="subtituloDaSecao('Telefone')">
                <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">DDD</label>
                        <p-inputmask formControlName="telefoneDdd" mask="99" placeholder="00" styleClass="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Número do Telefone</label>
                        <p-inputmask formControlName="telefoneNumero" mask="99999-9999" placeholder="00000-0000" styleClass="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Horário para Contato</label>
                        <p-inputmask formControlName="horarioContato" mask="99:99 - 99:99" placeholder="08:00 - 18:00" styleClass="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Tipo</label>
                        <p-select [appendTo]="'body'" formControlName="telefoneTipo" [options]="telefoneTipoOptions" placeholder="Selecione" class="w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-4 gap-3 mt-3">
                    <div class="field"><label class="font-semibold block mb-2">DDD residencial</label><p-inputmask formControlName="telefoneResidencialDdd" mask="99" placeholder="00" styleClass="w-full" /></div>
                    <div class="field"><label class="font-semibold block mb-2">Telefone residencial</label><p-inputmask formControlName="telefoneResidencialNumero" mask="99999-9999" placeholder="00000-0000" styleClass="w-full" /></div>
                    <div class="field"><label class="font-semibold block mb-2">DDD correspondência</label><p-inputmask formControlName="telefoneCorrespondenciaDdd" mask="99" placeholder="00" styleClass="w-full" /></div>
                    <div class="field"><label class="font-semibold block mb-2">Telefone correspondência</label><p-inputmask formControlName="telefoneCorrespondenciaNumero" mask="99999-9999" placeholder="00000-0000" styleClass="w-full" /></div>
                </div>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPreMedico.DEF) {
            <div>
                <app-card-content [headerColor]="false" [title]="'Tipo Deficiência'" [icon]="iconeDaSecao('Tipo Deficiência')" [subtitle]="subtituloDaSecao('Tipo Deficiência')">
                    <div class="field">
                        <p-select [appendTo]="'body'" formControlName="deficienciaTipo" [options]="deficienciaTipoOptions" placeholder="Selecione" class="w-full" />
                    </div>
                </app-card-content>
                <app-card-content [headerColor]="false" [title]="'Outras*'" [icon]="iconeDaSecao('Outras*')" [subtitle]="subtituloDaSecao('Outras*')">
                    <textarea rows="6" formControlName="deficienciaOutras" class="w-full"></textarea>
                </app-card-content>
                <app-card-content [headerColor]="false" [title]="'Origem'" [icon]="iconeDaSecao('Origem')" [subtitle]="subtituloDaSecao('Origem')">
                    <div class="field">
                        <p-select [appendTo]="'body'" formControlName="deficienciaOrigem" [options]="deficienciaOrigemOptions" placeholder="Selecione" class="w-full" />
                    </div>
                </app-card-content>
                <app-card-content [headerColor]="false" [title]="'Adaptado'" [icon]="iconeDaSecao('Adaptado')" [subtitle]="subtituloDaSecao('Adaptado')">
                    <div class="field">
                        <p-select [appendTo]="'body'" formControlName="deficienciaAdaptado" [options]="yesNoOptions" placeholder="Selecione" class="w-full" />
                    </div>
                </app-card-content>
            </div>
        }
        @if (abaSelecionada() === EAbaPreMedico.FORM) {
            <div class="grid gap-5">
                <app-card-content [headerColor]="false" [title]="'Formação'" [icon]="iconeDaSecao('Formação')" [subtitle]="subtituloDaSecao('Formação')">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <label class="font-semibold block mb-2">Tipo de Formação</label>
                            <p-select [appendTo]="'body'" formControlName="tipoFormacao" [options]="tipoFormacaoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Comprovante de Graduação</label>
                            <p-select [appendTo]="'body'" formControlName="comprovanteGraduacao" [options]="comprovanteGraduacaoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                    </div>

                    <div class="field-with-action">
                        <div class="field">
                            <label class="font-semibold block mb-2">Nome da Escola</label>
                            <input pInputText formControlName="nomeEscola" class="w-full" />
                        </div>
                        <div class="flex items-end pb-1">
                            <p-button icon="pi pi-search" ariaLabel="Buscar escola" (onClick)="abrirPesquisaEscola()" />
                        </div>
                    </div>

                    <div class="field-with-action">
                        <div class="field">
                            <label class="font-semibold block mb-2">País de Formação</label>
                            <p-select [appendTo]="'body'" formControlName="paisFormacao" [options]="paises" placeholder="Selecionar" class="w-full" />
                        </div>
                        <div class="flex items-end pb-1">
                            <p-button icon="pi pi-search" ariaLabel="Buscar país de formação" />
                        </div>
                    </div>

                    <div class="field">
                        <label class="font-semibold block mb-2">Nome da Escola Estrangeira</label>
                        <input pInputText formControlName="nomeEscolaEstrangeira" class="w-full" />
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'Dados do Curso'" [icon]="iconeDaSecao('Dados do Curso')" [subtitle]="subtituloDaSecao('Dados do Curso')">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">Livro Registro</label>
                            <input pInputText formControlName="livroRegistro" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Número do Processo</label>
                            <input pInputText formControlName="numeroProcesso" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Início do Curso</label>
                            <p-inputmask formControlName="inicioCurso" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Dt. Conclusão</label>
                            <p-inputmask formControlName="dtConclusao" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'Registro e Diploma'" [icon]="iconeDaSecao('Registro e Diploma')" [subtitle]="subtituloDaSecao('Registro e Diploma')">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">Folha Número</label>
                            <input pInputText formControlName="folhaNumero" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Registro do MEC</label>
                            <input pInputText formControlName="registroMec" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Dt. Formatura</label>
                            <p-inputmask formControlName="dtFormaturaForm" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Exp. Diploma</label>
                            <input pInputText formControlName="expDiploma" class="w-full" />
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">Dt. de Reg. MEC</label>
                            <p-inputmask formControlName="dtRegMec" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                        <div class="field md:col-span-2">
                            <label class="font-semibold block mb-2">Apresentou o diploma?</label>
                            <p-select [appendTo]="'body'" formControlName="apresentouDiploma" [options]="yesNoOptions" class="w-full" />
                        </div>
                    </div>
                </app-card-content>
            </div>
        }
        @if (abaSelecionada() === EAbaPreMedico.DOC) {
            <div class="grid gap-5">
                <!-- Carteira de Identidade + CPF -->
                <app-card-content [headerColor]="false" [title]="'Carteira de Identidade'" [icon]="iconeDaSecao('Carteira de Identidade')" [subtitle]="subtituloDaSecao('Carteira de Identidade')">
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">Registro Geral</label>
                            <input pInputText formControlName="numeroRg" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Org. Exp.</label>
                            <input pInputText formControlName="orgExpedidor" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">UF</label>
                            <p-select [appendTo]="'body'" formControlName="ufRg" [options]="ufs" placeholder="UF" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Dt. Emissão</label>
                            <p-inputmask formControlName="dtEmissaoRg" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'CPF'" [icon]="iconeDaSecao('CPF')" [subtitle]="subtituloDaSecao('CPF')">
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                        <div class="field md:col-span-1">
                            <label class="font-semibold block mb-2">Número</label>
                            <input pInputText formControlName="cpfNumero" class="w-full" />
                        </div>
                    </div>
                </app-card-content>

                @if (!isEstrangeiro) {
                    <!-- Título de Eleitor -->
                    <app-card-content [headerColor]="false" [title]="'Título de Eleitor'" [icon]="iconeDaSecao('Título de Eleitor')" [subtitle]="subtituloDaSecao('Título de Eleitor')">
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                            <div class="field">
                                <label class="font-semibold block mb-2">Número do Título</label>
                                <input pInputText formControlName="tituloNumero" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Zona</label>
                                <input pInputText formControlName="tituloZona" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Seção</label>
                                <input pInputText formControlName="tituloSecao" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">UF</label>
                                <p-select [appendTo]="'body'" formControlName="tituloUf" [options]="ufs" placeholder="UF" class="w-full" />
                            </div>
                        </div>
                    </app-card-content>

                    <!-- Informações Militares -->
                    <app-card-content [headerColor]="false" [title]="'Informações Militares'" [icon]="iconeDaSecao('Informações Militares')" [subtitle]="subtituloDaSecao('Informações Militares')">
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
                            <div class="field">
                                <label class="font-semibold block mb-2">Número de Reservista</label>
                                <input pInputText formControlName="numeroReservista" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Situação Militar</label>
                                <p-select [appendTo]="'body'" formControlName="situacaoMilitar" [options]="situacaoMilitarOptions" placeholder="Selecione" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Região Militar</label>
                                <input pInputText formControlName="regiaoMilitar" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Validade do Cert. Militar</label>
                                <p-inputmask formControlName="validadeCertMilitar" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-3 mt-3">
                            <div class="field md:col-span-2">
                                <label class="font-semibold block mb-2">Comando</label>
                                <p-select [appendTo]="'body'" formControlName="comandoMilitar" [options]="comandoOptions" placeholder="Selecione" class="w-full" />
                            </div>
                        </div>
                    </app-card-content>
                }

                @if (isEstrangeiro) {
                    <!-- Registro Nacional de Estrangeiros -->
                    <app-card-content [headerColor]="false" [title]="'Registro Nacional de Estrangeiros'" [icon]="iconeDaSecao('Registro Nacional de Estrangeiros')" [subtitle]="subtituloDaSecao('Registro Nacional de Estrangeiros')">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div class="field">
                                <label class="font-semibold block mb-2">Nº Cédula Estrangeira</label>
                                <input pInputText formControlName="cedulaEstrangeira" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Data de Emissão</label>
                                <p-inputmask formControlName="dtEmissaoCedula" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
                            <div class="field">
                                <label class="font-semibold block mb-2">Nº do Passaporte</label>
                                <input pInputText formControlName="numeroPassaporte" class="w-full" />
                            </div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Dt. Validade do Visto</label>
                                <p-inputmask formControlName="dtValidadeVisto" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                            </div>
                        </div>
                    </app-card-content>
                }
            </div>
        }

        @if (abaSelecionada() === EAbaPreMedico.CORR) {
            <div class="grid gap-5">
                <app-card-content [headerColor]="false" [title]="'Endereço'" [icon]="iconeDaSecao('Endereço')" [subtitle]="subtituloDaSecao('Endereço')">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <label class="font-semibold block mb-2">CEP</label>
                            <p-inputmask formControlName="cep" mask="99999-999" placeholder="00000-000" styleClass="w-full" (onBlur)="preencherMunicipioPorCep()" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Tipo</label>
                            <p-select [appendTo]="'body'" formControlName="tipoEndereco" [options]="tipoEnderecoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                    </div>

                    <div class="field">
                        <label class="font-semibold block mb-2">Endereço</label>
                        <input pInputText formControlName="endereco" class="w-full" />
                    </div>

                    <div class="field">
                        <label class="font-semibold block mb-2">Bairro</label>
                        <input pInputText formControlName="bairro" class="w-full" />
                    </div>

                    <div class="field">
                        <label class="font-semibold block mb-2">Município</label>
                        <p-select [appendTo]="'body'" formControlName="municipioId" [options]="municipios" placeholder="Selecionar" class="w-full" (onChange)="onMunicipioSelecionado($event.value)" />
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
                            <div class="field"><label class="font-semibold block mb-2">CEP de correspondência</label><p-inputmask formControlName="cepCorrespondencia" mask="99999-999" placeholder="00000-000" styleClass="w-full" /></div>
                            <div class="field"><label class="font-semibold block mb-2">Endereço de correspondência</label><input pInputText formControlName="enderecoCorrespondenciaTexto" class="w-full" /></div>
                            <div class="field"><label class="font-semibold block mb-2">Bairro de correspondência</label><input pInputText formControlName="bairroCorrespondencia" class="w-full" /></div>
                            <div class="field">
                                <label class="font-semibold block mb-2">Município de correspondência</label
                                ><p-select [appendTo]="'body'" formControlName="municipioCorrespondenciaId" [options]="municipios" placeholder="Selecionar" class="w-full" (onChange)="onMunicipioCorrespondenciaSelecionado($event.value)" />
                            </div>
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'Preferências de Endereço'" [icon]="iconeDaSecao('Preferências de Endereço')" [subtitle]="subtituloDaSecao('Preferências de Endereço')">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">End. Correspondência?</label>
                            <p-select [appendTo]="'body'" formControlName="enderecoCorrespondencia" [options]="yesNoOptions" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Endereço Atualizado?</label>
                            <p-select [appendTo]="'body'" formControlName="enderecoAtualizado" [options]="yesNoOptions" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Divulgar Endereço?</label>
                            <p-select [appendTo]="'body'" formControlName="divulgarEndereco" [options]="yesNoOptions" class="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="false" [title]="'Comunicação'" [icon]="iconeDaSecao('Comunicação')" [subtitle]="subtituloDaSecao('Comunicação')">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">Receber jornal?</label>
                            <p-select [appendTo]="'body'" formControlName="receberJornal" [options]="yesNoOptions" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Receber Informativos?</label>
                            <p-select [appendTo]="'body'" formControlName="receberInformativos" [options]="yesNoOptions" class="w-full" />
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-[3fr_1fr] gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">Email</label>
                            <input pInputText formControlName="email" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Tipo</label>
                            <p-select [appendTo]="'body'" formControlName="emailTipo" [options]="emailTipoOptions" placeholder="Selecionar" class="w-full" />
                        </div>
                    </div>
                </app-card-content>
            </div>
        }

        @if (abaSelecionada() === EAbaPreMedico.ANEXOS) {
            <div class="grid gap-5">
                <app-card-content [headerColor]="false" [title]="'Anexos Disponiveis'" [icon]="iconeDaSecao('Anexos Disponiveis')" [subtitle]="subtituloDaSecao('Anexos Disponiveis')">
                    @if (anexosDisponiveis().length === 0) {
                        <div class="feedback">Nenhum anexo disponível para visualização.</div>
                    } @else {
                        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                            @for (anexo of anexosDisponiveis(); track anexo.chave) {
                                <article class="campo campo--anexo">
                                    <span class="campo-label">{{ anexo.titulo }}</span>
                                    @if (possuiAnexo(anexo)) {
                                        <button type="button" class="campo-link-botao" (click)="onVisualizarAnexo($event, anexo)" aria-label="Visualizar anexo" title="Visualizar anexo">
                                            <i class="pi pi-paperclip"></i>
                                            <span>Visualizar anexo</span>
                                        </button>
                                    } @else {
                                        <strong class="campo-valor">-</strong>
                                    }
                                </article>
                            }
                        </div>
                    }
                </app-card-content>
            </div>
        }

        @if (abaSelecionada() === EAbaPreMedico.REVISAO) {
            <app-card-content [headerColor]="false" [title]="'Revisao da Solicitacao'" [icon]="iconeDaSecao('Revisao da Solicitacao')" [subtitle]="subtituloDaSecao('Revisao da Solicitacao')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="campo">
                        <span class="campo-label">Solicitante</span><strong class="campo-valor">{{ form.get('cpfNumero')?.value || '-' }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Formação</span><strong class="campo-valor">{{ form.get('nomeEscola')?.value || '-' }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Endereço</span><strong class="campo-valor">{{ form.get('endereco')?.value || '-' }}</strong>
                    </div>
                    <div class="campo">
                        <span class="campo-label">Telefone</span><strong class="campo-valor">{{ form.get('telefoneNumero')?.value || '-' }}</strong>
                    </div>
                </div>
            </app-card-content>
        }

        @if (jsonAtualizacao()) {
            <app-card-content [headerColor]="false" [title]="'JSON de Atualização'" [icon]="iconeDaSecao('JSON de Atualização')" [subtitle]="subtituloDaSecao('JSON de Atualização')">
                <pre>{{ jsonAtualizacao() }}</pre>
            </app-card-content>
        }

        <div class="wizard-acoes">
            <p-button label="Anterior" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" [disabled]="indiceEtapaAtual() === 0 || salvando()" (onClick)="etapaAnterior()" />
            @if (indiceEtapaAtual() < etapasWizard.length - 1) {
                <p-button label="Próxima" icon="pi pi-arrow-right" iconPos="right" [disabled]="salvando()" (onClick)="proximaEtapa()" />
            } @else {
                <p-button label="Efetivar solicitação" icon="pi pi-check" [disabled]="salvando() || efetivacaoJaConcluida()" [appCan]="rolePreMedicoConfirmar" (onClick)="concluirWizard()" />
            }
        </div>
    </form>
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>

<app-pesquisar-escola-dialog [(showDialog)]="exibirPesquisaEscola" tipo="GRAD" (saved)="selecionarEscola($event)"></app-pesquisar-escola-dialog>
